export const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const REALADVISOR_PORTAL_ID = '51a0d37a-80f5-11e8-bedf-1791f1a4be3f';
